import React from 'react'
import './main.css'
import image from '../../images/First Apearance/image.png'
import circle from '../../images/Navbar Menu/Vector.png'

export default function Appearance() {
    return (
        <>
            <div className="appearance">
                <div className="appearance-header">
                    <h1>Остекление квартир и домов от производителя</h1>
                    <p>Установим без наценок посредников за 5 дней с расширенной гарантией</p>
                    <div className="list-group">
                        <div className='list'>
                            <div className='circle'>
                                <img src={circle} alt="error" />
                            </div>
                            <span>Гарантия до 10 лет</span>
                        </div>
                        <div className='list'>
                            <div className='circle'>
                                <img src={circle} alt="error" />
                            </div>
                            <span>Рассрочка 0% без переплат</span>
                        </div>
                        <div className='list'>
                            <div className='circle'>
                                <img src={circle} alt="error" />
                            </div>
                            <span>Бесплатный замер</span>
                        </div>
                    </div>
                    <button>Рассчитать стоимость</button>
                </div>
                <div className="image">
                    <img src={image} alt="" />
                </div>
            </div>
        </>
    )
}